<template>
  <router-link
    :to="{ name: 'program-detail', params: { slug: data.slug } }"
    class="program-wrapper link-block"
  >
    <img :src="`${data.img || ''}`" alt="Image" />
    <div class="program-content">
      <p class="program-summary">
        {{ data.desc_short || '' }}
      </p>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'campaign',
  props: ['link', 'data'],
};
</script>

<style></style>
